import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import ContexteFiscalPageModal from "pages/audit complet/contexte fiscal/contexte fiscal pager";
import ContratFacPersoModal from "pages/audit complet/simulation/contrat facultatif perso";
import React, { useContext, useState } from "react";
import { FaEdit, FaGlobe } from "react-icons/fa";

function OptimisationRevenus(props) {
  const { Revenus, AutresRevenus, IRTotal, CotisationsFacPerso,ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalContexteFiscalOpen, setmodalContexteFiscalOpen] = useState(false);
  const [modalContratFacPerso, setmodalContratFacPerso] = useState(false);
  let CliConj = ClientConjoint === "" ? "" : "Conjoint";
  let CliConjRai = (ClientConjoint === ""  ||ClientConjoint === "ConjointAssocie" )? "" : "Conjoint";

  
  const handleCotisationsFacPersoOptiRem = () => {
    let CotFacPerso =  Number(context.state.OptiRemCotFacPerso);

    // console.log(CotFacPerso);
    if (context.state.InclureConjoint === true && props.Periode?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
        CotFacPerso += +Number(context.state.OptiRemCotFacPersoConjoint);
    }

        // console.log(CotFacPerso);
        // if (ClientConjoint==="Conjoint") {
            CotFacPerso +=Number(context.state.OptiRemCotFacPersoConjoint);
        // }
    return CotFacPerso;
  };

  return (
    <CardBox className="blockRoundedForce" bpad>
      <table className="simulation">
        <tbody>
          <tr>
            <td className="libelle">Revenus d'activités perçus</td>
            <td className="origine">{applyFormat(Revenus, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="space">&nbsp;</td>
            <td className="nouvelle pr4">{applyFormat(context.state.OptiRemRevPercus, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>

            <td className="extra">&nbsp;</td>
            <td className="ecart"> {ApplySignedFormat(Number(context.state.OptiRemRevPercus) - Number(Revenus))}</td>
          </tr>
          <tr>
            <td className="libelle">Autres revenus du foyer</td>
            <td className="origine">{applyFormat(AutresRevenus, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="space">&nbsp;</td>
            <td className="nouvelle pr4">{applyFormat(context.state.OptiRemRevenusFoyer, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="extra">&nbsp;</td>
            <td className="ecart"> {ApplySignedFormat(Number(context.state.OptiRemRevenusFoyer) - Number(AutresRevenus))}</td>
          </tr>
          <tr>
            <td className="libelle">Impôt sur le revenu</td>
            <td className="origine">{applyFormat(IRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="space">&nbsp;</td>
            <td className="nouvelle pr4">
              <Button
                className="editIconOptiRem"
                onClick={() => {
                  setmodalContexteFiscalOpen(true);
                }}
                icon
                style={{ display: "inline-block" }}
              >
                <FaEdit />
              </Button>
              {applyFormat(context.state.OptiRemIRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </td>
            <td className="extra">&nbsp;</td>
            <td className="ecart"> {ApplySignedFormat(Number(context.state.OptiRemIRTotal) - Number(IRTotal))}</td>
          </tr>
          <tr>
            <td className="libelle">Cotisations facultatives personnelles</td>
            <td className="origine">{applyFormat(CotisationsFacPerso, "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="space">&nbsp;</td>
            <td className="nouvelle pr4">
            <Button
                className="editIconOptiRem"
                onClick={() => {
                  setmodalContratFacPerso(true);
                }}
                icon
                style={{ display: "inline-block" }}
              >
                <FaEdit />
              </Button>
              {applyFormat(handleCotisationsFacPersoOptiRem(), "uint", { thousands: " ", decimal: ",", unit: " €" })}</td>
            <td className="extra">&nbsp;</td>
            <td className="ecart"> {ApplySignedFormat(handleCotisationsFacPersoOptiRem()- Number(CotisationsFacPerso))}</td>
          </tr>
        </tbody>
      </table>

      <Modal
        width="80%"
        height="80%"
        title="Contexte fiscal"
        icon={<FaGlobe />}
        visible={modalContexteFiscalOpen}
        onClose={() => {
          context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
          setmodalContexteFiscalOpen(false);
        }}
      >
        <ContexteFiscalPageModal
          Outil="OptiRem"
          visible={modalContexteFiscalOpen}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
            setmodalContexteFiscalOpen(false);
          }}
        />
      </Modal>
      <Modal
        width="80%"
        height="80%"
        title="Paramètres"
        icon={<FaGlobe />}
        visible={modalContratFacPerso}
        onClose={() => {
          context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
          setmodalContratFacPerso(false);
        }}
      >
        <ContratFacPersoModal
        ClientConjoint={props.ClientConjoint}
          Outil="OptiRem"
          visible={modalContratFacPerso}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
            setmodalContratFacPerso(false);
          }}
        />
      </Modal>
    </CardBox>
  );
}
export default OptimisationRevenus;
